import { FileUploader } from './FileUploader'
import { Control } from './Control'
import { FilesList } from './FilesList'

FileUploader.Control = Control
FileUploader.FilesList = FilesList

export { FileUploader }
